function toPlainError(err) {
  try {
    if (!err) return null
    if (err instanceof Error) {
      return {
        name: err.name,
        message: err.message,
        stack: err.stack,
      }
    }
    if (typeof err === 'object') {
      return {
        name: String(err.name || 'Error'),
        message: String(err.message || ''),
        stack: typeof err.stack === 'string' ? err.stack : undefined,
      }
    }
    return { name: 'Error', message: String(err) }
  } catch {
    return { name: 'Error', message: 'unserializable_error' }
  }
}

function safeJson(value) {
  try {
    return JSON.parse(JSON.stringify(value))
  } catch {
    return null
  }
}

export function logEvent(level, event, payload) {
  try {
    const entry = {
      ts: new Date().toISOString(),
      level: String(level || 'info'),
      event: String(event || 'event'),
      payload: safeJson(payload) ?? null,
    }
    const out = `[sofera] ${JSON.stringify(entry)}` 
    if (level === 'error') console.error(out)
    else if (level === 'warn') console.warn(out)
    else console.log(out)
  } catch {
    try {
      console.log('[sofera] log_failed')
    } catch {
      return
    }
  }
}

export function logError(event, error, payload) {
  logEvent('error', event, { ...(payload || {}), error: toPlainError(error) })
}
